import { FeedbackForm } from './feedback-form'
import { QuestCategories } from './categories'

export function initFeedbackForm(): void {
  const feedbackFormEl = document.querySelector<HTMLElement>(
    '[data-form="feedback"]'
  )
  if (!feedbackFormEl) {
    return
  }

  new FeedbackForm(feedbackFormEl)
}

export function initCategories(): void {
  const categories = document.querySelectorAll<HTMLElement>(
    '[data-quest-categories]'
  )

  categories.forEach((categoriesEl) => new QuestCategories(categoriesEl))
}
